import { z } from "zod";

import { OTHER_MATTERS } from "./MeetingMinutesForm.options";

const otherMattersSchema = z.object(
  Object.fromEntries(OTHER_MATTERS.map((m) => [m.key, z.boolean()])) as Record<
    (typeof OTHER_MATTERS)[number]["key"],
    z.ZodBoolean
  >
);

const taskRowSchema = z.object({
  task: z.string(),
  owner: z.string(),
  deadline: z.string(),
  status: z.string(),
});

export const meetingMinutesSchema = z.object({
  docRefMeetPlace: z.string().min(1, "Place is required"),
  docRefMeetDate: z.string().min(1, "Date is required"),
  docRefMeetPart: z.string(),
  docRefDet: z.string(),
  otherCases: otherMattersSchema,
  tasks: z.array(taskRowSchema).min(1),
});

export type MeetingMinutesData = z.infer<typeof meetingMinutesSchema>;
